<mat-card
    class="daxa-card active-courses-card mb-25 border-radius bg-white border-none d-block"
    [class.component-dark-theme]="themeService.isDark()"
>
    <mat-card-content>
        <mat-card-header>
            <mat-card-title>
                <h5 class="mb-0">
                    Savings
                </h5>
            </mat-card-title>
        </mat-card-header>

        <div class="icon text-center bg-warning rounded-circle text-white position-relative mx-auto">
            <i class="material-symbols-outlined">
                attach_money
            </i>
        </div>

        <div class="info d-flex align-items-center justify-content-between">
            <div class="sub-section text-start">
                <span class="sub-title d-block text-body fw-medium">Today</span>
                <div class="number fw-medium lh-1"> -</div>
            </div>
            <div class="sub-section text-end">
                <span class="sub-title d-block text-body fw-medium">This Year</span>
                <div class="number fw-medium lh-1"> -</div>
            </div>
        </div>
    </mat-card-content>
</mat-card>